/* istanbul ignore file */

import { EnumField, FieldProps } from 'framework/ui/field';
import React from 'react';
import { PUBLICATION_PLATFORM } from 'domain/recruiting/newVacancy/show/publications/vacancyPublicationService';

const PublicationPlatformField = (props: FieldProps) => {
  return <EnumField {...props} options={PUBLICATION_PLATFORM} />;
};

export default PublicationPlatformField;
